/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/self-closing-comp */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import clsx from 'clsx';
import { NavLink, useLocation } from 'react-router';
import { useSwipeable } from 'react-swipeable';

import { fixPhoneNumber } from '../../utils/common';
import { Logo } from '../Logo/Logo';
import { useAppConfigContext } from '../../hooks/useAppConfigContext';
import { useDimensions } from '../../hooks/useDimensions';

import styles from './Header.module.css';
import { Modal } from '../Modal/Modal';
import { ContactForm } from '../ContactForm/ContactForm';

// eslint-disable-next-line react/display-name
export const Header = ({
  getPaddings,
}: {
  getPaddings: (padding: number) => void;
}) => {
  const config = useAppConfigContext();
  const location = useLocation();

  const [open, setOpen] = useState(false);
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isNavHover, setIsNavHover] = useState(false);
  const [transparent, setTransparent] = useState(true);

  const headerRef = useRef<HTMLElement | null>(null);
  const { height: headerHeight, windowWidth } = useDimensions(
    headerRef,
    config,
  );

  const openDialog = () => {
    setOpen(true);
  };

  const closeDialog = () => {
    setOpen(false);
  };

  const handleMenu = () => {
    setIsNavOpen((prev) => {
      if (!prev) setIsNavHover(false);
      return !prev;
    });
  };

  const handlers = useSwipeable({
    onSwipedUp: () => {
      setIsNavOpen(false);
      setIsNavHover(false);
    },
    preventScrollOnSwipe: true,
  });

  const paddingCalc = useMemo(
    () => ({ top: `${headerHeight}px` }),
    [headerHeight, windowWidth],
  );

  useEffect(() => getPaddings(headerHeight), [headerHeight]);

  useEffect(() => {
    if (location.pathname === '/') {
      setTransparent(true);
    } else {
      setTransparent(false);
    }
  }, [location.pathname]);

  return (
    <div>
      <header
        className={clsx(
          styles.container,
          !transparent && styles.fillContainer,
          isNavHover || isNavOpen ? 'bg-opacity-80' : null,
        )}
        ref={headerRef}
      >
        <div className={styles.content}>
          <nav>
            <section className={styles.menuBox}>
              <button
                className={
                  isNavOpen ? styles.menuButtonActive : styles.menuButton
                }
                onClick={handleMenu}
                type="button"
                aria-label="button"
                onMouseEnter={() => setIsNavHover(true)}
                onMouseLeave={() => setIsNavHover(false)}
                // aria-expanded="false"
                // aria-controls="list"
              >
                <span className={styles.menuButtonLine} />
                <span className={styles.menuButtonLine} />
              </button>
              <div
                style={paddingCalc}
                className={clsx(
                  styles.hideMenuNav,
                  isNavOpen && styles.showMenuNav,
                )}
                {...handlers}
              >
                <ul className={styles.menuList}>
                  <NavLink
                    className={styles.menuLink}
                    to="/"
                    onClick={handleMenu}
                  >
                    Главная
                  </NavLink>
                  <NavLink
                    to="/portfolio"
                    onClick={handleMenu}
                    className={styles.menuLink}
                  >
                    Портфолио
                  </NavLink>
                </ul>
              </div>
            </section>
          </nav>
          <Logo />
          <div className={styles.contactsBox}>
            <div className={styles.tel}>
              <a
                className={styles.link}
                href={`tel:${fixPhoneNumber(config.phoneNumber)}`}
              >
                {config.phoneNumber}
              </a>
            </div>
            {/* <MessengerIcon
              type="telegram"
              className="text-sm xs:text-lg 2xl:text-xlg"
            />
            <MessengerIcon
              type="whatsapp"
              className="text-sm xs:text-lg 2xl:text-xlg"
            /> */}
            <button
              type="button"
              onClick={openDialog}
              className={styles.contactButton}
            >
              <p>Связаться</p>
            </button>
          </div>
        </div>
      </header>
      {open && (
        <Modal
          open={open}
          onClose={closeDialog}
          closeButton={false}
          containerStyles={styles.modalBox}
        >
          <ContactForm />
        </Modal>
      )}
    </div>
  );
};
